export default {
    namespaced: true,

    state: {
        currentPopup: null,
    },

    getters: {

    },

    mutations: {
        setCurrentPopup(state, popup) {
            state.currentPopup = popup;
        },
        
    },

    actions: {
        setCurrentPopup({commit}, popup) {
            commit('setCurrentPopup', popup);
        },
        
        clearCurrentPopup({dispatch}) {
            dispatch('setCurrentPopup', null);
        },
        
        openLineEditPopup({dispatch}, {id, type, fromPoint, toPoint}) {

            const centerOfLine = function() {
                let x = fromPoint.x + (toPoint.x - fromPoint.x) / 2;
                let y = fromPoint.y + (toPoint.y - fromPoint.y) / 2;

                return {x, y};
            };
            
            let position = centerOfLine();
            
            let popup = {
                type: 'LinePopup', // the popup's type using for set which of popup components need to use
                position,
                line: {
                    id,
                    type,
                    fromPoint,
                    toPoint,
                },
            };

            dispatch('setCurrentPopup', popup);
        },

        openLineWithRibsEditPopup({dispatch}, { baseLine, type, fromPoint, toPoint }) {

            const centerOfLine = function() {
                let diffLength = fromPoint.x + (toPoint.x - fromPoint.x) / 2;
                let angle = baseLine.angle360 / 180 * Math.PI;

                let dx = diffLength * Math.cos(angle);
                let dy = diffLength * Math.sin(angle);

                let x = baseLine.fromPoint.x + dx;
                let y = baseLine.fromPoint.y + dy;

                return {x, y};
            };

            let position = centerOfLine();
            
            let popup = {
                type: 'LinePopup',
                position,
                line: {
                    type,
                    fromPoint: baseLine.fromPoint,
                    toPoint: baseLine.toPoint,
                },
                lineWithRibsPart: {
                    fromPoint: fromPoint,
                    toPoint: toPoint,
                },
            };

            dispatch('setCurrentPopup', popup);
        },

        openHemEditPopup({rootGetters, dispatch}, hemId) {
            let position = rootGetters['editor/getPointById'](hemId);

            let popup = {
                type: 'HemPopup',
                position,
                hemId,
            };

            dispatch('setCurrentPopup', popup);
        },

        openAngleEditPopup({dispatch}, {pointCenter, angleSize}) {
            let popup = {
                type: 'AnglePopup',
                position: pointCenter,
                angle: angleSize,
                centerPoint: pointCenter,
            };

            dispatch('setCurrentPopup', popup);
        },
        
    },
}